// @flow
import cookies from 'browser-cookies'

const COOKIE_PREFIX = 'stemning_'
const COOKIE_MAXAGE = 365

type CookieValue = {
  hasVoted: boolean,
  selectedAlternativeId: number
}

function toCookieName (pollId: number) {
  return `${COOKIE_PREFIX}_${pollId}`
}

export function getSelectedAlternativeId (pollId: number): ?number {
  const cookie = getCookie(pollId)
  return cookie && cookie.selectedAlternativeId
}

export function getCookie (pollId: number): ?CookieValue {
  const cookieName = toCookieName(pollId)
  const cookieValueAsString = cookies.get(cookieName)
  try {
    return JSON.parse(cookieValueAsString)
  } catch (error) {
    return null
  }
}

export function setHasVoted (pollId: number, alternativeId: number) {
  const cookieName = toCookieName(pollId)
  const cookieValue = JSON.stringify({
    hasVoted: true,
    selectedAlternativeId: alternativeId
  })
  const cookieOptions = { expires: COOKIE_MAXAGE }

  cookies.set(cookieName, cookieValue, cookieOptions)
}

export function hasVoted (pollId: number) {
  const cookie = getCookie(pollId)
  return cookie && cookie.hasVoted
}

export function cookiesEnabled () {
  return navigator.cookieEnabled
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/helpers/cookieUtils.js